import { useNavigate } from "react-router-dom";
import { Sparkles, LayoutDashboard, Smartphone, ArrowRight, Globe } from "lucide-react";

export default function Landing() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAF7F2] text-stone-900">
      <div className="max-w-6xl mx-auto px-5 py-10 sm:py-16">
        <div className="flex items-center gap-2 text-[#4A1D24]">
          <Sparkles className="h-5 w-5 text-[#C59B6C]" />
          <span className="text-sm tracking-[0.35em] font-semibold">VELOURS &amp; SILK</span>
        </div>

        <div className="mt-14 sm:mt-20 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <p className="text-xs font-semibold uppercase tracking-widest text-amber-800/80">Treueprogramm</p>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] mt-3">
              Jeder Besuch <span className="italic text-[#4A1D24]">belohnt</span>. Jede Kundin im Blick.
            </h1>
            <p className="font-sans text-base text-stone-600 leading-relaxed mt-5 max-w-md">
              Sammeln Sie Treuepunkte, verwalten Sie Prämien und behalten Sie den Überblick — mit
              automatischen E-Mails, digitaler Kundenkarte und sicherem Kundenportal.
            </p>
          </div>

          <div className="lg:col-span-6 grid sm:grid-cols-2 gap-4">
            <button
              data-testid="enter-admin-button"
              onClick={() => nav("/admin")}
              className="group text-left rounded-2xl bg-[#4A1D24] text-stone-50 p-6 shadow-xl border border-amber-500/10 transition-transform hover:-translate-y-1"
            >
              <LayoutDashboard className="h-7 w-7 text-[#C59B6C]" />
              <h3 className="font-serif text-2xl mt-4">Salon-Admin</h3>
              <p className="text-sm text-stone-300/80 mt-1">Kundinnen &amp; Punkte verwalten</p>
              <span className="inline-flex items-center gap-1 text-sm text-[#E7C79A] mt-4 group-hover:gap-2 transition-all">
                Anmelden <ArrowRight className="h-4 w-4" />
              </span>
            </button>

            <button
              data-testid="enter-portal-button"
              onClick={() => nav("/portal")}
              className="group text-left rounded-2xl bg-white p-6 shadow-lg border border-stone-200/80 transition-transform hover:-translate-y-1"
            >
              <Smartphone className="h-7 w-7 text-[#4A1D24]" />
              <h3 className="font-serif text-2xl mt-4 text-stone-900">Kundenportal</h3>
              <p className="text-sm text-stone-500 mt-1">Punkte &amp; Prämien ansehen</p>
              <span className="inline-flex items-center gap-1 text-sm text-[#4A1D24] mt-4 group-hover:gap-2 transition-all">
                Öffnen <ArrowRight className="h-4 w-4" />
              </span>
            </button>

            <button
              data-testid="enter-website-admin-button"
              onClick={() => nav("/website-admin")}
              className="group sm:col-span-2 text-left rounded-2xl bg-[#F1EAE0] p-6 shadow-md border border-[#C59B6C]/30 transition-transform hover:-translate-y-1 flex items-center gap-5"
            >
              <Globe className="h-7 w-7 text-[#4A1D24] shrink-0" />
              <span className="flex-1">
                <h3 className="font-serif text-2xl text-stone-900">Website verwalten</h3>
                <p className="text-sm text-stone-600 mt-1">Logo, Leistungen, Angebote, Galerie, Öffnungszeiten &amp; Kontaktdaten der öffentlichen Website bearbeiten (eigenes Login)</p>
              </span>
              <span className="inline-flex items-center gap-1 text-sm text-[#4A1D24] group-hover:gap-2 transition-all">
                Website-Admin <ArrowRight className="h-4 w-4" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
